/**
 * Normalize values that come from Spatie HasTranslations.
 *
 * The backend stores translatable fields (title, description, label_singular…)
 * as JSON objects like {"es":"…","en":"…"}. When Eloquent serializes those
 * models without applying a locale (e.g. listings) the API returns the raw
 * object. This helper unwraps it to a plain string so React can render it.
 */
export type Localized = string | null | undefined | Record<string, unknown>;

export function pickLocalized(value: Localized, locale = 'es', fallback = ''): string {
  if (value == null) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    const v = value as Record<string, unknown>;
    const candidate = v[locale] ?? v.es ?? v.en ?? Object.values(v)[0];
    if (typeof candidate === 'string') return candidate;
  }
  return fallback;
}
